<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>시험 신청</p></li>
            <li><p>합격자 조회</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>합격자 조회</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="table mt30">
            <div class="row head">
              <div class="cell fix150"><p>번호</p></div>
              <div class="cell"><p>제목</p></div>
              <div class="cell fix150"><p>접수일</p></div>
              <div class="cell fix150"><p>합격자 발표일</p></div>
              <div class="cell fix180"><p>결과 조회</p></div>
            </div>
            <div class="row" v-for="(item, index) in list" :key="index">
              <div class="cell fix150"><p>{{ index + 1 }}</p></div>
              <div class="cell">
                <p class="left">
                  {{ item.exam.examinationName }}
                </p>
              </div>
              <div class="cell fix150"><p>{{ $moment(item.examRegDate).format('YYYY.MM.DD') }}</p></div>
              <div class="cell fix150"><p>{{ $moment(item.exam.passDate).format('YYYY.MM.DD') }}</p></div>
<!--              {{ Number($moment(item.exam.passDate).format('YYYYMMDD')) }}-->
<!--              {{  today }}-->
              <div class="cell fix180">
                <button class="btn bo" :class="{ 'grey' : item.userExam.passStatus !== 1 }">
                  {{ $Util.isEmpty(item.userExam.passStatus) || item.userExam.passStatus === 0 ? '결과대기' : item.userExam.passStatus === 1 ? '합격' : '불합격'}}
                </button>
              </div>
            </div>
            <div class="page_con" v-if="$Util.isEmpty(list)">
              <div class="empty_wrap">
                <div class="empty">
                  <span>내역이 존재하지 않습니다.</span>
                </div>
              </div>
            </div>
          </div>
          <pagination
            v-bind="pageInfo"
            v-model="pageInfo.page"
            @change="fetchPassData"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manager-exam-pass-index',
  data() {
    return {
      list: [],
      pageInfo: {},
      params: {
        page: 1,
        limit: 10
      },
      today: this.$moment(new Date()).format('YYYYMMDD')
    }
  },
  computed: {
    today_date: function(val) {
      console.log(val)
      return 0
    }
  },
  async created() {
    const res = await this.$ManagerSvc.fetchUserCertList(this.params)
    console.log('test', res)
    this.list = res.entity.list
    this.pageInfo = res.entity.pageInfo
  },
  methods: {
    fetchPassData: async function() {
      const res = await this.$ManagerSvc.fetchUserCertList(this.params)
      this.list = res.entity.list
      this.pageInfo = res.entity.pageInfo
    }
  }
}
</script>

<style scoped></style>
